import { render, staticRenderFns } from "./FormiumFormBuilderItem.vue?vue&type=template&id=3f71a56e"
import script from "./FormiumFormBuilderItem.vue?vue&type=script&lang=js"
export * from "./FormiumFormBuilderItem.vue?vue&type=script&lang=js"
import style0 from "./FormiumFormBuilderItem.vue?vue&type=style&index=0&id=3f71a56e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports